import React from 'react';
import ReactModal from 'react-modal';

import styles from '../../../../stylesheet/css/header-builder/modal.css';

const renderHeader = header => {
  if (!header) {
    return null;
  }

  const title = typeof header === 'string' ? header : header.title;

  return (
    <div className={styles.header}>
      <h3>{title}</h3>
    </div>
  );
};

const renderBody = body => {
  if (!body) {
    return null;
  }

  return (
    <div className={styles.body}>
      {body}
    </div>
  );
};

const renderFooter = footer => {
  if (!footer) {
    return null;
  }

  const commands = Array.isArray(footer) ? footer : footer.commands;

  return (
    <div className={styles.footer}>
      {commands.map(c => (
        <span
          key={c.text}
          className={styles.commandButton}
          onClick={c.onClick}
        >
          {c.text}
        </span>
      ))}
    </div>
  );
};

const Modal = ({ header, children, footer, width, style = {}, ...rest }) => {
  const { content: contentStyle, ...restStyles } = style;

  return (
    <ReactModal
      className={styles.content}
      overlayClassName={styles.overlay}
      style={{
        content: { width, ...contentStyle },
        ...restStyles
      }}
      {...rest}
    >
      {renderHeader(header)}
      {renderBody(children)}
      {renderFooter(footer)}
    </ReactModal>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./app/header-builder/components/Modal.js